// src/components/services/ServicePageTechStack.js
import React from 'react';
// Assurez-vous que ce fichier contient bien les champs imageUrl et altText pour chaque technologie
import { techStackData } from '../../data/techStackData'; 
import './ServicePageTechStack.css';

function ServicePageTechStack() {
  // Vous pouvez choisir d'afficher toutes les technos ou une sélection pertinente ici
  // Par exemple, pour afficher les 15 premières :
  const relevantTechs = techStackData.slice(0, 18); 

  return (
    <section className="service-page-tech-stack-container">
      <h2 className="section-title">Les Technologies au Cœur de Nos Services</h2>
      <p className="section-intro">
        Nous utilisons une palette d'outils et de technologies modernes et éprouvées pour construire des solutions digitales performantes, robustes et adaptées à vos ambitions.
      </p>
      <div className="spts-tech-grid"> {/* Classe préfixée */}
        {relevantTechs.map(tech => (
          <div key={tech.name} className="spts-tech-card"> {/* Classe préfixée */}
            <div className="spts-logo-wrapper">
              <img 
                src={tech.imageUrl} 
                alt={tech.altText || tech.name} 
                className="spts-tech-logo-image" 
                loading="lazy" // Ajout du lazy loading pour les images
              />
            </div>
            <h3 className="spts-tech-name">{tech.name}</h3> {/* Classe préfixée */}
            {/* La catégorie est optionnelle ici, comme dans votre exemple */}
            {/* {tech.category && <p className="spts-tech-category">{tech.category}</p>} */}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicePageTechStack;